import {
    FOLLOW_STATUS,
    FOLLOW_TIER,
    NOTIFICATION_TYPE,
    POST_TYPE,
} from "./constants";
import currency from "currency.js";

const randomColor = [
    "#f44336",
    "#e91e63",
    "#9c27b0",
    "#673ab7",
    "#2196f3",
    "#009688",
    "#4caf50",
    "#8bc34a",
    "#ff9800",
    "#fbe9e7",
    "#556ee6",
    "#564ab1",
    "#6f42c1",
    "#f46a6a",
    "#34c38f",
    "#50a5f1",
];

// Cookie
export const setCookie = (data) => {
    const d = new Date();
    d.setDate(d.getDate() + 1);
    const expires = `expires=${d.toUTCString()}`;
    document.cookie = `${data[0]}=${data[1]};${expires};path=/`;
};

export const getCookie = (cname) => {
    const name = `${cname}=`;
    const ca = document.cookie.split(";");
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === " ") {
            c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
};

export const deleteCookie = (data) => {
    const d = new Date();
    d.setDate(d.getDate() + 1);
    // const expires = `expires=${d.toUTCString()}`;
    document.cookie = `${data}= ; expires= Thu, 21 Aug 2014 20:00:00 UTC`;
};

export const UniversalValidator = (data) => {
    if (!data.isValidate || data.value.length <= 0) return data.errorMsg;
    return "";
};

export const emailValidator = (email) => {
    const re = /\S+@\S+\.\S+/;

    if (!email || email.length <= 0) return "Email cannot be empty.";
    if (!re.test(email)) return "Ooops! We need a valid email address.";

    return "";
};

export const linkValidator = (data) => {
    const re = /^(ftp|http|https):\/\/[^ "]+$/;
    if (data || data.length > 0) {
        if (!re.test(data))
            return "Ooops! We need a valid website.(http://|https://|ftp://)";
    }

    return "";
};

export function numberOnly(value) {
    return value.replace(/[^\d]/g, "");
}

export function abnFormat(value) {
    return value.replace(/[^\d ]/g, "");
}

export const getFirstWord = (data) => {
    const firstWord = data.replace(/ .*/, "");
    return firstWord;
};

export const getColor = (data) => {
    if (randomColor[data]) {
        return randomColor[data];
    }
    // Math.floor(Math.random()*16777215).toString(16)
    return "#fbaf42";
};

export const customStyles = {
    option: (provided, state) => ({
        ...provided,
        borderBottom: "1px solid #ECECF5",
        color: state.isSelected ? "#fff" : "#8890AB",
        padding: 6,
        fontSize: 12,
    }),
    placeholder: (base) => ({
        ...base,
        color: "#AFB6CB",
        fontSize: 12,
    }),
    control: (base) => ({
        ...base,
        border: "0 !important",
        // This line disable the blue border
        boxShadow: "0 !important",
        "&:hover": {
            border: "0 !important",
        },
    }),
    singleValue: (base) => ({
        ...base,
        // backgroundColor: '#F8F8FB',
        // border: '1px solid #ECECF5',
        // boxSizing: 'border-box',
        // borderRadius: 50,
        // paddingLeft: 10,
        // paddingRight: 10,
        fontSize: 12,
    }),
    multiValue: (base) => ({
        ...base,
        backgroundColor: "#F8F8FB",
        border: "1px solid #ECECF5",
        boxSizing: "border-box",
        borderRadius: 50,
        paddingLeft: 10,
        paddingRight: 10,
    }),
    multiValueLabel: (base) => ({
        ...base,
        fontSize: 12,
    }),
};

export const asyncDebouncer = (fn, wait, callFirst) => {
    var timeout;
    return function () {
        return new Promise(async (resolve) => {
            if (!wait) {
                const result = await fn.apply(this, arguments);
                resolve(result);
            }

            const context = this;
            const args = arguments;
            const callNow = callFirst && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(async function () {
                timeout = null;
                if (!callNow) {
                    const result = await fn.apply(context, args);
                    resolve(result);
                }
            }, wait);

            if (callNow) {
                const result = await fn.apply(this, arguments);
                resolve(result);
            }
        });
    };
};

export const doScrolling = (elementY, duration) => {
    var startingY = window.pageYOffset;
    var diff = elementY - startingY;
    var start;

    // Bootstrap our animation - it will get called right before next frame shall be rendered.
    window.requestAnimationFrame(function step(timestamp) {
        if (!start) start = timestamp;
        // Elapsed milliseconds since start of scrolling.
        var time = timestamp - start;
        // Get percent of completion in range [0, 1].
        var percent = Math.min(time / duration, 1);

        window.scrollTo(0, startingY + diff * percent);

        // Proceed with animation as long as we wanted it to.
        if (time < duration) {
            window.requestAnimationFrame(step);
        }
    });
};

export const getRandomArbitrary = (min, max) =>
    Math.random() * (max - min) + min;

export const convertToCSV = (objArray) => {
    var array = typeof objArray != "object" ? JSON.parse(objArray) : objArray;
    var str = "";

    for (var i = 0; i < array.length; i++) {
        var line = "";
        for (var index in array[i]) {
            if (line != "") line += ",";

            line += array[i][index];
        }

        str += line + "\r\n";
    }

    return str;
};

export const exportCSVFile = (headers, items, fileTitle) => {
    if (headers) {
        items.unshift(headers);
    }

    // Convert Object to JSON
    let jsonObject = JSON.stringify(items);

    let csv = convertToCSV(jsonObject);

    let exportedFilenmae = fileTitle + ".csv" || "export.csv";

    let blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    if (navigator.msSaveBlob) {
        // IE 10+
        navigator.msSaveBlob(blob, exportedFilenmae);
    } else {
        const link = document.createElement("a");
        if (link.download !== undefined) {
            // feature detection
            // Browsers that support HTML5 download attribute
            const url = URL.createObjectURL(blob);
            link.setAttribute("href", url);
            link.setAttribute("download", exportedFilenmae);
            link.style.visibility = "hidden";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    }
};

export const checkImageExist = (url, callBack) => {
    const img = new Image();
    img.src = url;

    if (img.complete) {
        callBack(true);
    } else {
        img.onload = () => {
            callBack(true);
        };
        img.onerror = () => {
            callBack(false);
        };
    }
};

export const numberWithCommas = (x) => {
    if (x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
};

export const getNotificationIcon = (type) => {
    switch (type) {
        case NOTIFICATION_TYPE.ALERT:
            return {
                group: "fa-solid",
                icon: "fa-exclamation-triangle",
            };
        case NOTIFICATION_TYPE.COMMENT:
            return {
                group: "fa-regular",
                icon: "fa-comment",
            };
        case NOTIFICATION_TYPE.LIKES:
            return {
                group: "fa-regular",
                icon: "fa-heart",
            };
        case NOTIFICATION_TYPE.NEW_SUBSCRIBER:
            return {
                group: "fa-solid",
                icon: "fa-user-plus",
            };
        case NOTIFICATION_TYPE.PRICE_CHANGE:
            return {
                group: "fa-solid",
                icon: "fa-money-bill",
            };
        case NOTIFICATION_TYPE.UNMUTED:
            return {
                group: "fa-solid",
                icon: "fa-exchange-alt",
            };

        default:
            return "";
    }
};

export const checkAspectRatio = (ratio) => {
    if (parseFloat(ratio) >= 0.58 && parseFloat(ratio) < 0.9) {
        return " p_3_4";
    } else if (parseFloat(ratio) >= 0.42 && parseFloat(ratio) <= 0.57) {
        return " p_9_16";
    } else if (parseFloat(ratio) <= 0.41) {
        return " p_9_22";
    } else if (parseFloat(ratio) == 1) {
        return " p_1_1";
    } else if (parseFloat(ratio) == 1.33) {
        return " l_3_4";
    } else if (parseFloat(ratio) >= 1.34 && parseFloat(ratio) <= 2.43) {
        return " l_9_16";
    } else if (parseFloat(ratio) >= 2.44) {
        return " l_9_22";
    } else {
        return " p_1_1";
    }
};

export const bannedWords = (str) => {
    const words = [
        /onlyfans/gi,
        /0nlyfans/gi,
        /only[\s]+fans/gi,
        /0nly[\s]+fans/gi,
    ];
    words.forEach((bannedWord) => {
        str = str.replace(bannedWord, "");
    });

    return str;
};

export const isLogin = () => {
    const user = JSON.parse(localStorage.getItem("user"));
    return user && Object.keys(user).length > 0;
};

export const splitTime = (numberOfHours) => {
    const Days = Math.floor(numberOfHours / 24);
    const Remainder = numberOfHours % 24;
    const Hours = Math.floor(Remainder);
    const Minutes = Math.floor(60 * (Remainder - Hours));

    return {
        days: Days,
        hours: Hours,
        minutes: Minutes,
    };
};

export const bytesToSize = (bytes) => {
    const sizes = ["Bytes", "KB", "MB", "GB", "TB"];
    if (bytes === 0) return "n/a";
    const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10);
    if (i === 0) return `${bytes} ${sizes[i]})`;
    return `${(bytes / 1024 ** i).toFixed(1)} ${sizes[i]}`;
};

export const alphaNumeric = (e) => {
    let key;
    let keychar;

    if (window.event) {
        key = window.event.keyCode;
    } else if (e) {
        key = e.which;
    } else {
        return true;
    }

    keychar = String.fromCharCode(key);
    keychar = keychar.toLowerCase();

    // control keys
    if (
        key == null ||
        key == 0 ||
        key == 8 ||
        key == 9 ||
        key == 13 ||
        key == 27
    ) {
        return true;

        // alphas and numbers
    } else if ("abcdefghijklmnopqrstuvwxyz0123456789".indexOf(keychar) > -1) {
        return true;
    } else {
        return false;
    }
};

export const toFixedTrunc = (number, places) => {
    const str = `${number}`;
    const index = str.indexOf(".");
    if (index >= 0) {
        return str.slice(0, str.indexOf(".") + places + 1);
    }

    return number;
};

export const moneyFormat = (total) => {
    if (total > 1000000) {
        total /= 1000000;
        return currency(total, { precision: 2 }).format() + "M";
    }

    if (total > 1000) {
        total /= 1000;
        return currency(total, { precision: 2 }).format() + "K";
    }

    return currency(total).format();
};

export const totalCount = (n) => {
    if (n < 1e3) return n;
    if (n >= 1e3 && n < 1e6) return +(n / 1e3).toFixed(1) + "K";
    if (n >= 1e6 && n < 1e9) return +(n / 1e6).toFixed(1) + "M";
    if (n >= 1e9 && n < 1e12) return +(n / 1e9).toFixed(1) + "B";
    if (n >= 1e12) return +(n / 1e12).toFixed(1) + "T";
};

export const showImageCounter = (total) => {
    if (total === 0) return "";

    return (
        <>
            {total} <i className="fa-regular fa-image"></i>
        </>
    );
};

export const showVideoCounter = (total) => {
    if (total === 0) return "";

    return (
        <>
            {" "}
            {total} <i className="fa-solid fa-video"></i>
        </>
    );
};

export const showPrice = (price) => {
    if (price === 0) return "";

    return <>Price:&nbsp;{moneyFormat(price)}&nbsp;&nbsp;</>;
};

export const calculatePercentage = (amount, subscriptionPrice) => {
    let percent =
        100 - (parseFloat(amount) / parseFloat(subscriptionPrice)) * 100;
    percent = Math.round(percent / 5) * 5;
    return percent === 100 ? 95 : percent;
};

const padTo2Digits = (num) => {
    return num.toString().padStart(2, "0");
};

export const renderDuration = (totalSeconds) => {
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    let label = "";

    if (minutes >= 1) {
        label = `${padTo2Digits(minutes)}m`;
    }

    if (seconds > 0) {
        label += ` ${padTo2Digits(seconds)}s`;
    }

    return label;
};

export const scrollToBottom = (node) => {
    const element = document.querySelector(node);
    element.scrollTop = element.scrollHeight;
};

export const getFirstSegment = () => {
    const pathSegments = window.location.pathname.split("/");
    // Filter out empty segments
    const nonEmptySegments = pathSegments.filter(
        (segment) => segment.trim() !== ""
    );
    return nonEmptySegments.length > 0 ? nonEmptySegments[0] : null;
};

export const inFreeTiers = (tier) => {
    return [FOLLOW_TIER.FREE, FOLLOW_TIER.FREE_FOLLOW].includes(parseInt(tier));
};

export const notExpired = (subscriptionStatus) => {
    return [
        FOLLOW_STATUS.ACTIVE,
        FOLLOW_STATUS.UNFOLLOWED_DOES_NOT_RENEW,
    ].includes(parseInt(subscriptionStatus));
};

export const postTypeNeedsSubscription = (postType) => {
    return [
        POST_TYPE.SUBSCRIPTION_POST,
        POST_TYPE.PPV_WITH_PAID_SUBSCRIPTION,
    ].includes(parseInt(postType));
};

export const toTitleCase = (str) => {
    return str.replace(/\w\S*/g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
};

export const limit = (string = "", limit = 0) => string.substring(0, limit);
